<div class="flex-align-center flex cursor-pointer flex-nowrap">
    <div class="min-w-0 flex-1">
        <rwidget-route-name
            [routeNumberLabel]="route?.shortName"
            [routeNumberColor]="route?.icon?.color || route?.color"
            [routeNumberTextColor]="route?.icon?.textColor || route?.textColor"
            [routeNumberShape]="route?.icon?.shape || ShapeType.ROUNDED"
            [pickupType]="time?.pickupType"
            [dropOffType]="time?.dropOffType"
            [cancelled]="time.canceled"
            [name]="time?.headsign"></rwidget-route-name>
    </div>
    <div class="w-2"></div>
    <div
        class="vl-app-light:font-bold ml-auto mr-1 flex flex-wrap items-center whitespace-nowrap text-xl"
        *ngIf="
            !env.EXPLORE?.HIDE_DOUBLE_TIMES &&
                (env.EXPLORE.SCHEDULE_TIME_THRESHOLD_EARLY || env.EXPLORE.SCHEDULE_TIME_THRESHOLD_LATE) &&
                !isDepartureWithinThreshold;
            else otpFormat
        ">
        <div class="vl-app-light:font-bold ml-auto flex flex-nowrap items-center whitespace-nowrap text-xl">
            <ion-icon
                class="var-app-light-dark:scale-[1.2] drt-icon-text-color var-app-light:text-white mr-1 text-base dark:text-contrast-yellow"
                *ngIf="route.mode === TransportMode.Flexible"
                aria-hidden="true"
                src="{{ assetsPath$ | async }}/img/explore/drt-route-icon.svg">
            </ion-icon>
            <ng-container *ngIf="hasDisruptionOnRoute" [ngSwitch]="disruptionSeverityOnRoute">
                <ion-icon
                    class="var-app-dark:text-black orb-app-dark:text-black text-red-alert_icon orb-app-light:text-red-alert_icon mr-1 text-base"
                    *ngSwitchCase="DisruptionMessageSeverity.CRITICAL"
                    [attr.aria-label]="'ALERT' | translate"
                    src="{{ assetsPath$ | async }}/img/journey-planner/icon-alert-circle.svg"></ion-icon>
                <ion-icon
                    class="text-blue-alert_icon var-app-dark:text-black orb-app-dark:text-black mr-1 text-base"
                    *ngSwitchCase="DisruptionMessageSeverity.INFO"
                    [attr.aria-label]="'ALERT' | translate"
                    src="{{ assetsPath$ | async }}/img/journey-planner/icon-info-no-color.svg"></ion-icon>
                <ion-icon
                    class="var-app-light:text-yellow-secondary mr-1 text-base dark:text-contrast-yellow"
                    *ngSwitchDefault
                    [attr.aria-label]="'ALERT' | translate"
                    src="{{ assetsPath$ | async }}/img/journey-planner/alert.svg"></ion-icon>
            </ng-container>
            <ion-icon
                class="realtime-icon vl-app-light-dark:h-3 hu-light-dark:h-2 orb-app-light:text-yellow-secondary mr-1 text-base"
                *ngIf="
                    env?.EXPLORE?.SHOW_REALTIME_ICON &&
                    ((time.realtimeDeparture !== null && time.realtimeDeparture !== time.scheduledDeparture) ||
                        time.realtime)
                "
                aria-hidden="true"
                src="{{ assetsPath$ | async }}/img/explore/attributes.svg">
            </ion-icon>
            <div class="flex flex-col">
                <div class="flex items-center gap-1">
                    <span
                        class="leading-5"
                        [ngClass]="{
                            italic: env.TIMEPOINTS_ENABLED && !timepoint && !time.realtime
                        }">
                        {{ realTimeDeparture.epochMilliseconds | date: TIME_FORMAT : timeZoneOffset }}
                    </span>
                    <div
                        class="vl-app-light:text-black stop-point solid-border flex h-4 w-4 items-center justify-center rounded-full border border-gray-700 text-xs font-semibold dark:border-contrast-yellow dark:text-contrast-yellow"
                        *ngIf="time?.stopPoint">
                        <span class="dark:text-contrast-yellow">{{ time?.stopPoint }}</span>
                    </div>
                </div>
                <div class="flex items-end justify-end" *ngIf="isShowScheduledTimeBelowRealTime">
                    <span class="text-gray-dark text-sm line-through">
                        {{ scheduledTimeDeparture.epochMilliseconds | date: TIME_FORMAT : timeZoneOffset }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #otpFormat>
    <div class="vl-app-light:text-black ml-auto">
        <div class="vl-app-light:font-bold flex flex-nowrap items-center whitespace-nowrap text-xl">
            <ion-icon
                class="drt-icon-text-color var-app-light:text-white mr-1 text-base dark:text-contrast-yellow"
                *ngIf="route.mode === TransportMode.Flexible"
                aria-hidden="true"
                src="{{ assetsPath$ | async }}/img/explore/drt-route-icon.svg"></ion-icon>
            <ng-container *ngIf="hasDisruptionOnRoute" [ngSwitch]="disruptionSeverityOnRoute">
                <ion-icon
                    class="var-app-dark:text-black orb-app-dark:text-black text-red-alert_icon orb-app-light:text-red-alert_icon mr-1 text-base"
                    *ngSwitchCase="DisruptionMessageSeverity.CRITICAL"
                    [attr.aria-label]="'ALERT' | translate"
                    src="{{ assetsPath$ | async }}/img/journey-planner/icon-alert-circle.svg"></ion-icon>
                <ion-icon
                    class="text-blue-alert_icon var-app-dark:text-black orb-app-dark:text-black mr-1 text-base"
                    *ngSwitchCase="DisruptionMessageSeverity.INFO"
                    [attr.aria-label]="'ALERT' | translate"
                    src="{{ assetsPath$ | async }}/img/journey-planner/icon-info-no-color.svg"></ion-icon>
                <ion-icon
                    class="var-app-light:text-yellow-secondary mr-1 text-base dark:text-contrast-yellow"
                    *ngSwitchDefault
                    [attr.aria-label]="'ALERT' | translate"
                    src="{{ assetsPath$ | async }}/img/journey-planner/alert.svg"></ion-icon>
            </ng-container>
            <ion-icon
                class="realtime-icon orb-app-light:text-black vl-app-light:h-3 hu-light-dark:h-2 mr-1 text-base"
                *ngIf="
                    env?.EXPLORE?.SHOW_REALTIME_ICON &&
                    ((time.realtimeDeparture !== null && time.realtimeDeparture !== time.scheduledDeparture) ||
                        time.realtime)
                "
                aria-hidden="true"
                src="{{ assetsPath$ | async }}/img/explore/attributes.svg"></ion-icon>
            <ion-icon
                class="mr-1 mt-1 h-[0.875rem] w-4 self-baseline"
                *ngIf="env.EXPLORE.SHOW_CANCELLED_STATUS && time.canceled"
                aria-hidden="true"
                src="{{ assetsPath$ | async }}/img/alert-cancelled.svg"></ion-icon>

            <span
                [ngClass]="{
                    'text-danger line-through': env.EXPLORE?.SHOW_CANCELLED_STATUS && time.canceled,
                    'italic': !timepoint && env.TIMEPOINTS_ENABLED
                }">
                {{ mainDisplayTime }}
            </span>
            <div
                class="vl-app-light:text-black stop-point solid-border ml-1 flex h-4 w-4 items-center justify-center rounded-full border border-gray-700 text-xs font-semibold dark:border-contrast-yellow dark:text-contrast-yellow"
                *ngIf="time?.stopPoint">
                <span class="dark:text-contrast-yellow">{{ time?.stopPoint }}</span>
            </div>
        </div>
        <p
            class="align-right mt-1 block w-full whitespace-normal text-base leading-5 text-[#5E5E5E] dark:text-contrast-yellow"
            *ngIf="crossedOutTime && env.TIMEPOINTS_ENABLED"
            [attr.aria-hidden]="true">
            <span class="line-through">{{ crossedOutTime }}</span>
        </p>
    </div>
</ng-template>
